import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _4gMobiledataIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"4g_mobiledata"} ref={ref}/>
});

_4gMobiledataIcon.displayName = "_4gMobiledataIcon";
